module.exports = __webpack_public_path__ + "img/avatar7.edfda461.png";